export default function getHospitalLink(hospital, link) {
  if (!link) return '#'
  if (link.startsWith('tel:') || link.startsWith('mailto:')) return link
  if (
    !link.startsWith('/') ||
    !hospital ||
    hospital === 'group' ||
    hospital === 'undefined'
  )
    return link
  if (!hospital || hospital === 'undefined') return link
  // Remove any existing hospital prefix to prevent duplicates
  const hospitalPrefix = `/${hospital}`
  if (link.startsWith(hospitalPrefix)) {
    return link
  }

  return `${hospitalPrefix}${link}`
}
